import { render, staticRenderFns } from "./NotificationsDropdown.vue?vue&type=template&id=c447197e&scoped=true&"
import script from "./NotificationsDropdown.vue?vue&type=script&lang=js&"
export * from "./NotificationsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsDropdown.vue?vue&type=style&index=0&id=c447197e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c447197e",
  null
  
)

export default component.exports